module.exports = __webpack_public_path__ + "img/placeholder_image.29c35035.svg";